import React, { useState, useEffect, useRef, useCallback } from "react";
import { Tooltip, Button, Typography, Tag } from "antd";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  reload,
  loadPage,
  setMonth,
  setYear,
  setBranch,
  setTextFilter,
  resetProspectuses,
  generateMasavReport,
} from "./prospectusesSlice";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import {
  resetProspectus,
  setActiveProspectusId,
  setActiveProspectusBranch,
} from "../prospectus/prospectusSlice";
import CreateFileModal from "./components/CreateFileModal";
import { useIntl } from "react-intl";
import moment from "moment";
import ActionsTable from "../../components/templates/ActionsTable";
import FullScreenModal from "../../components/templates/FullScreenModal";
import Surface from "../../components/layouts/Surface";
import { ReactComponent as ClientsImg } from "../../assets/no-clients.svg";
import Header from "./components/Header";
import Prospectus from "../prospectus/index";
import PaymentRequests from "../paymentRequests/index";
import {
  ZoomInOutlined,
  DownloadOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { reset } from "../paymentRequests/paymentRequestsSlice";
import Currency from "../../components/tables/Currency";
import { useParams, useLocation } from "react-router-dom";
import { listClients } from "../../api/server";
import {
  generateBtlFile,
  generateKerenFile,
  generateClalitFile,
} from "../../api/server";
import { openURL } from "../../components/util/helpers";
import { notifyError } from "../notifications/notificationsSlice";
import debounce from "lodash.debounce";
import { isAllowedFeature } from "../organization/organizationSlice";
import GenerateMasavReportTable from "./components/GenerateMasavReportTable";
const { Text } = Typography;

const Prospectuses = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  let location = useLocation();
  let { branchId } = useParams();
  const prospectus_export = useSelector(
    (state) => state.organization.details.prospectus_export
  );
  const organizationDetails = useSelector(
    (state) => state.organization.details
  );
  const [newPaymentRequestsVisible, setNewPaymentRequestsVisible] =
    useState(false);
  const [prospectusVisible, setProspectusVisible] = useState(false);
  const [createFileVisible, setCreateFileVisible] = useState(false);
  const [createFileMode, setCreateFileMode] = useState(null);
  const [data, setData] = useState([]);
  const [prospectuses, setProspectuses] = useState([]);
  const [tableItems, setTableItems] = useState([]);
  const [generateMasavReportItems, setGenerateMasavReportItems] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeDate, setActiveDate] = useState(moment().subtract(1, "months"));
  const [downloadingFileId, setDownloadingFileId] = useState(null);
  const [generatingMasavReportId, setGeneratingMasavReportId] = useState(null);
  const activeYear = useSelector((state) => state.prospectuses.activeYear);
  const activeMonth = useSelector((state) => state.prospectuses.activeMonth);
  const textFilter = useSelector((state) => state.prospectuses.textFilter);
  const activeBranch = useSelector((state) => state.prospectuses.activeBranch);
  const activeClient = useSelector((state) => state.prospectuses.activeClient);
  const { page: prospectusesPage } = useSelector((state) => state.prospectuses);
  const { current, pageSize, total, items, filter, order } = prospectusesPage;
  const loading = useSelector(
    (state) => state.pendingActions["prospectuses/loadPage"]
  );
  const isAdmin = location.pathname.includes("admin");
  const scopePrefix = isAdmin ? `` : `branches/${branchId}/`;
  useEffect(() => {
    dispatch(loadPage({ current: 1, filter: filter }));
  }, [
    activeMonth,
    activeYear,
    textFilter,
    activeBranch,
    activeClient,
    dispatch,
  ]);
  useEffect(() => {
    if (items && items.length > 0) {
      let arr = [];
      let expanded = [];
      let tableArr = [];

      items.forEach((item, i) => {
        const temp = { ...item, children: null };
        arr.push(temp);
        if (item.children && item.children.length > 0) {
          const children = item.children.filter((k) => k.type !== "refund");
          const refundItems = item.children.filter((k) => k.type === "refund");
          if (refundItems && refundItems.length > 0) {
            refundItems.forEach((refundItem, j) => {
              const parentSerial = refundItem["serial_number"]
                .toString()
                .substring(1);
              const index = children.findIndex(
                (item) => parentSerial === item.serial_number.toString()
              );
              children.splice(index + 1, 0, refundItem);
            });
          }
          const expandedItem = { ...item, children };
          tableArr.push(expandedItem);
        } else {
          tableArr.push(temp);
        }
        expanded.push(item.id);
        if (item.children && item.children.length > 0) {
          item.children.forEach((child, j) => {
            arr.push(child);
          });
        }
      });
      setProspectuses(arr);
      setTableItems(tableArr);
      setExpandedRowKeys(expanded);
    } else {
      setProspectuses([]);
      setTableItems([]);
      setExpandedRowKeys([]);
    }
  }, [items]);

  useEffect(() => {
    return function cleanup() {
      dispatch(resetProspectuses());
    };
  }, [dispatch]);

  useEffect(() => {
    listClients({ current: 1, pageSize: 100, scopePrefix }).then(
      ({ error, data }) => {
        if (data) {
          setData(data.items);
          let clientCategories = [];
          data.items.forEach((item, i) => {
            clientCategories.push(item.category);
          });
          const unique = [
            ...new Map(
              clientCategories.map((item) => [item["id"], item])
            ).values(),
          ];
          setCategories(unique);
        }
      }
    );
  }, [scopePrefix, items]);

  // Create a debounced version of dispatch that waits 500ms after the last call to invoke the action.
  const onTextChange = useRef(
    debounce((value) => {
      dispatch(setTextFilter({ text: value }));
    }, 500)
  ).current;

  const onExpandedRowsChange = (rows) => {
    setExpandedRowKeys(rows);
  };

  const onDateChange = (date, dateString) => {
    var month = date ? date.format("M") : null;
    var year = date ? date.format("YYYY") : null;
    dispatch(setMonth({ month: month }));
    dispatch(setYear({ year: year }));
    setActiveDate(date);
  };

  const onYearChange = (date, dateString) => {
    var year = date ? date.format("YYYY") : null;
    dispatch(setYear({ year: year }));
  };

  const onBranchChange = (val) => {
    dispatch(setBranch({ branch: val }));
  };

  const onShowNewPaymentRequests = () => {
    setNewPaymentRequestsVisible(true);
  };

  const onHideNewPaymentRequests = () => {
    setNewPaymentRequestsVisible(false);
    dispatch(reset());
    dispatch(loadPage({ current: 1, filter: filter }));
  };

  const onShowProspectuses = (record) => {
    setProspectusVisible(true);
    dispatch(setActiveProspectusId(record.id));
    dispatch(setActiveProspectusBranch(record.branch_id));
  };

  const onHideProspectus = () => {
    setProspectusVisible(false);
    dispatch(loadPage({ current: 1, filter: filter }));
    dispatch(resetProspectus());
  };

  const onHideBtlFile = () => {
    setCreateFileVisible(false);
  };

  const onShowUploadFile = (val) => {
    setCreateFileVisible(true);
    setCreateFileMode(val);
  };

  const onDownloadClientFile = async (record) => {
    const params = {
      year: +record.year,
      month: +record.month,
      prospectuses: [record.id],
    };

    setDownloadingFileId(record.id);

    try {
      const action = record.client_social_security
        ? await generateBtlFile(params, record.branch_id)
        : record["client.clalit"]
        ? await generateClalitFile(params, record.branch_id)
        : await generateKerenFile(params, record.branch_id);

      openURL(action.file_url);
    } catch (e) {
      dispatch(
        notifyError({ title: "generate_accounting", message: e.error || e })
      );
    } finally {
      setDownloadingFileId(null);
    }
  };

  const onGenerateMasavReport = async (record) => {
    setGeneratingMasavReportId(record.id);

    try {
      const params = {
        year: +record.year,
        month: +record.month,
        prospectuses: [record.id],
      };

      const data = {
        branchId: record.branch_id,
        params: params,
      };

      const action = await dispatch(generateMasavReport(data));
      if (!action.error) {
        if (action.payload?.data?.file_url) {
          openURL(action.payload.data.file_url);
        }
        const responseItems = action.payload?.data?.report?.Rows || [];
        setGenerateMasavReportItems(responseItems);
      }
    } catch (error) {
      console.error("Error generating Masav report:", error);
    } finally {
      setGeneratingMasavReportId(null);
    }
  };

  const hideGenerateMasavReportTable = () => {
    setGenerateMasavReportItems([]);
  };

  const isSupportingCommunityAllowed = isAllowedFeature("supporting_community");
  const isProspectusExportAllowed = isAllowedFeature("prospectus_upload");
  const showUploadedAt = isProspectusExportAllowed && prospectus_export?.active;

  const [selectedClientCategories, setSelectedClientCategories] = useState([]);

  // Update this function to handle multiple category selections
  const handleClientCategoryFilterChange = useCallback((filters) => {
    const categoryFilters = filters["client_category_name"];
    setSelectedClientCategories(categoryFilters || []);
  }, []);

  const sortFilterOptions = useCallback(
    (a, b) => a.text.localeCompare(b.text),
    []
  );

  const hasMerhav = organizationDetails?.accounting_export_type === "מרחב";
  const columns = [
    {
      title: "prospectus_id",
      sortIndex: "serial_number",
      sorter: true,
      responsive: ["md"],
      ellipsis: true,
      render: (r) => {
        return (
          <div>
            <Text>{r.record["serial_number"]}</Text>
            {r.record.is_self_participating && (
              <div>
                <Text style={{ fontSize: "12px", color: "#1890ff" }}>
                  {intl.formatMessage({
                    id: "app.prospectuses.is_self_participating",
                  })}
                </Text>
              </div>
            )}
          </div>
        );
      },
      width: "140px",
      fixed: "left",
    },
    ...(isAdmin
      ? [
          {
            title: "branch",
            render: (r) => {
              return <Text>{r.record["branch.name"]}</Text>;
            },
            width: "120px",
          },
        ]
      : []),
    {
      title: "client_category_id",
      render: (r) => {
        return <Text>{r.record["client_category_name"]}</Text>;
      },
      filters: categories
        .map((item) => ({
          text: item.name,
          value: item.id,
        }))
        .sort(sortFilterOptions),
      sortIndex: "client_category_name",
      sorter: true,
      width: "120px",
    },
    {
      title: "client_id",
      render: (r) => {
        return <Text>{r.record["client_name"]}</Text>;
      },
      filters: data
        .filter(
          (item) =>
            selectedClientCategories.length === 0 ||
            selectedClientCategories.includes(item.category_id)
        )
        .map((item) => ({
          text: item.name,
          value: item.id,
        }))
        .sort(sortFilterOptions),
      sortIndex: "client_name",
      sorter: true,
      width: "120px",
    },
    {
      title: "prospectus_type",
      width: "100px",

      render: (r) => {
        return (
          <Text>
            {r.record.supporting_community
              ? intl.formatMessage({
                  id: "app.prospectuses.supporting_community",
                })
              : r.record.day_center
              ? intl.formatMessage({
                  id: "app.prospectuses.day_center",
                })
              : intl.formatMessage({
                  id: "app.prospectuses.home_care",
                })}
          </Text>
        );
      },
    },
    {
      title: "debit_account_number",
      render: (r) => {
        const debitNumber = r.record["client.debit_account_number"]
          ? r.record["client.debit_account_number"]
          : r?.record?.client
          ? r.record.client.debit_account_number
          : "";
        return (
          <Text
            ellipsis={{
              tooltip: debitNumber,
            }}
          >
            {debitNumber}
          </Text>
        );
      },
      width: "100px",
    },
    {
      title: "date",
      width: "100px",
      sortIndex: "service_start_date",
      sorter: true,
      render: (r) => {
        return (
          <Text>
            {r.record["service_start_date"] &&
              moment(r.record["service_start_date"]).format("MM/YYYY")}
          </Text>
        );
      },
    },
    {
      title: "charged_units",
      responsive: ["md"],
      width: "120px",
      ellipsis: true,
      render: (r) => (
        <Text style={{ direction: "ltr", unicodeBidi: "bidi-override" }}>
          {r.record.charged_units}
        </Text>
      ),
    },
    {
      title: "charged_amount",
      responsive: ["md"],
      ellipsis: true,
      width: "120px",
      render: (r) =>
        r.record.type !== "refund" && (
          <Currency text={r.record["charged_amount"]} />
        ),
    },
    {
      title: "refund_amount",
      responsive: ["md"],
      ellipsis: true,
      width: "120px",
      render: (r) => <Currency text={r.record["refund_amount"]} />,
    },
    {
      title: "paid_amount",
      responsive: ["md"],
      ellipsis: true,
      width: "120px",
      render: (r) =>
        r.record.type !== "refund" && (
          <Currency text={r.record["paid_amount"]} />
        ),
    },
    {
      title: "reclaimed_amount",
      responsive: ["md"],
      ellipsis: true,
      width: "120px",
      render: (r) => <Currency text={r.record["reclaimed_amount"]} />,
    },
    {
      title: "balance",
      responsive: ["md"],
      ellipsis: true,
      width: "120px",
      render: (r) => (
        <Currency
          text={r.record["balance"]}
          alert={r.record.type === "refund"}
        />
      ),
      sortIndex: "balance",
      sorter: true,
    },
    {
      title: "over_payment_amount",
      responsive: ["md"],
      ellipsis: true,
      width: "120px",
      render: (r) => <Currency text={r.record["over_payment_amount"]} />,
    },
    {
      title: "status",
      responsive: ["md"],
      ellipsis: true,
      width: "100px",
      render: (r) =>
        r.record.canceled ? (
          <Tag color="error">
            {<FormattedMessage id="app.prospectuses.canceled" />}
          </Tag>
        ) : r.record.type === "refund" ? (
          <Tag color="processing">
            {<FormattedMessage id="app.prospectuses.refund" />}
          </Tag>
        ) : r.record.balanced && !r.record.locked ? (
          <Tag>
            {<FormattedMessage id="app.prospectuses.waiting_for_Approval" />}
          </Tag>
        ) : (
          r.record.balanced &&
          r.record.locked && (
            <Tag color="success" icon={<LockOutlined />}>
              {<FormattedMessage id="app.prospectuses.approved" />}
            </Tag>
          )
        ),
    },
    ...(hasMerhav
      ? [
          {
            title: "annual_serial_number",
            width: "100px",
            render: (r) => {
              return <Text>{r.record["annual_serial_number"]}</Text>;
            },
          },
        ]
      : []),
    ...(showUploadedAt
      ? [
          {
            title: "uploaded_at",
            width: "100px",
            render: (r) => {
              return r?.record?.uploaded_at ? (
                <Text>
                  {r.record["uploaded_at"] &&
                    moment(r.record["uploaded_at"]).format("MM/YYYY")}
                </Text>
              ) : (
                <Tooltip
                  title={intl.formatMessage({
                    id: "app.prospectuses.notUploaded",
                  })}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <ExclamationCircleOutlined style={{ color: "#faad14" }} />
                  </div>
                </Tooltip>
              );
            },
          },
        ]
      : []),
    {
      title: "actions",
      responsive: ["md"],
      width: "130px",
      fixed: "right",
      render: ({ record }) => (
        <div style={{ display: "flex" }}>
          <Tooltip
            title={intl.formatMessage({
              id: "app.prospectuses.showForecast",
            })}
          >
            <Button
              type="text"
              icon={<ZoomInOutlined />}
              onClick={() => onShowProspectuses(record)}
            />
          </Tooltip>
          {record.pending_amount !== 0 &&
            !record.is_self_participating &&
            (record.client_social_security ||
              record.client_category_name === "הקרן לנפגעי שואה" ||
              record["client.clalit"]) &&
            record.canceled !== true &&
            record.type !== "refund" && (
              <Tooltip
                title={intl.formatMessage({
                  id: "app.prospectuses.downloadProspectusFile",
                })}
              >
                <Button
                  type="text"
                  icon={<DownloadOutlined />}
                  onClick={() => onDownloadClientFile(record)}
                  loading={downloadingFileId === record.id}
                />
              </Tooltip>
            )}
          {record.is_self_participating && (
            <Tooltip
              title={intl.formatMessage({
                id: "app.prospectuses.generate_masav_report",
              })}
            >
              <Button
                type="text"
                icon={<DownloadOutlined />}
                onClick={() => onGenerateMasavReport(record)}
                loading={generatingMasavReportId === record.id}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <Surface style={{ width: window.innerWidth - 240 }}>
      <Header
        activeYear={activeYear}
        activeDate={activeDate}
        onDateChange={onDateChange}
        onYearChange={onYearChange}
        onTextChange={onTextChange}
        onBranchChange={onBranchChange}
        reload={reload}
        activeBranch={activeBranch}
        onShowNewPaymentRequests={onShowNewPaymentRequests}
        prospectuses={prospectuses}
        onShowUploadFile={onShowUploadFile}
      />
      <div style={{ height: "10px" }} />
      <ActionsTable
        tableItems={columns}
        category={"prospectuses"}
        resource="prospectuses"
        current={current}
        pageSize={pageSize}
        total={total}
        loading={loading}
        order={order}
        filtersType={{ client_id: "number", client_category_id: "number" }}
        textFilter={textFilter}
        reload={loadPage}
        loadPage={loadPage}
        skipInitialLoad={true}
        items={tableItems}
        showheader={false}
        emptyImage={<ClientsImg />}
        emptytext={""}
        expandableStyle={true}
        expandable={{
          expandedRowKeys: expandedRowKeys,
          onExpandedRowsChange: onExpandedRowsChange,
        }}
        filtersDataIndex={{
          client_category_name: "client_category_id",
          client_name: "client_id",
        }}
        scroll={window.innerHeight - 416}
        onTableChange={(pagination, filters, sorter) => {
          handleClientCategoryFilterChange(filters);
        }}
      />

      <FullScreenModal
        visible={newPaymentRequestsVisible}
        onHide={onHideNewPaymentRequests}
      >
        <PaymentRequests />
      </FullScreenModal>
      <FullScreenModal visible={prospectusVisible} onHide={onHideProspectus}>
        <Prospectus onHide={onHideProspectus} />
      </FullScreenModal>
      <CreateFileModal
        visible={createFileVisible}
        createFileMode={createFileMode}
        onHide={onHideBtlFile}
        prospectuses={prospectuses.filter(
          (item) => !item.is_self_participating
        )}
      />
      <GenerateMasavReportTable
        visible={generateMasavReportItems.length > 0}
        items={generateMasavReportItems}
        onHide={hideGenerateMasavReportTable}
      />
    </Surface>
  );
};

export default Prospectuses;
